import { render, staticRenderFns } from "./TicketReply.vue?vue&type=template&id=03f09966&"
import script from "./TicketReply.vue?vue&type=script&lang=js&"
export * from "./TicketReply.vue?vue&type=script&lang=js&"
import style0 from "./TicketReply.vue?vue&type=style&index=0&id=03f09966&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports